/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { enumType } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";

export enum FaultCategoryEnum {
  "PAYMENT_DUPLICATED" = "PAYMENT_DUPLICATED",

  "PAYMENT_ONGOING" = "PAYMENT_ONGOING",

  "PAYMENT_EXPIRED" = "PAYMENT_EXPIRED",

  "PAYMENT_UNAVAILABLE" = "PAYMENT_UNAVAILABLE",

  "PAYMENT_UNKNOWN" = "PAYMENT_UNKNOWN",

  "DOMAIN_UNKNOWN" = "DOMAIN_UNKNOWN",

  "PAYMENT_CANCELED" = "PAYMENT_CANCELED",

  "GENERIC_ERROR" = "GENERIC_ERROR",

  "PAYMENT_DATA_ERROR" = "PAYMENT_DATA_ERROR"
}

/**
 * Fault code categorization for the PagoPA Verifica and Attiva operations.
 * Possible categories are:
 * - `PAYMENT_DUPLICATED`
 * - `PAYMENT_ONGOING`
 * - `PAYMENT_EXPIRED`
 * - `PAYMENT_UNAVAILABLE`
 * - `PAYMENT_UNKNOWN`
 * - `DOMAIN_UNKNOWN`
 * - `PAYMENT_CANCELED`
 * - `GENERIC_ERROR`
 * - `PAYMENT_DATA_ERROR`
 */

export type FaultCategory = t.TypeOf<typeof FaultCategory>;
export const FaultCategory = enumType<FaultCategoryEnum>(
  FaultCategoryEnum,
  "FaultCategory"
);
